import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Indicator from '../../../static/arrow-blue.png'
import Link from '../Link'
import { ReversedGradientBorder } from '../commons'

const CustomerUseCases = ({ title, subtitle, components }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.topUseCase}>
            <h4 className={styles.caseTitle}>{components[0].title}</h4>
            <div className={[styles.caseDescription, 'paragraph'].join(' ')}>
              {components[0].subtitle.subtitle.split('\n')[0]}
            </div>
            {components[0].subtitle.subtitle.split('\n').length > 1 && (
              <div className={styles.readMore}>
                <Link
                  to={
                    components[0].subtitle.subtitle.split('\n')[1].split(';')[1]
                  }
                  children={
                    <React.Fragment>
                      <span className="paragraph">
                        {
                          components[0].subtitle.subtitle
                            .split('\n')[1]
                            .split(';')[0]
                        }
                      </span>
                      <img
                        className={styles.arrow}
                        src={Indicator}
                        alt="Customer Use Case Indicator"
                      />
                    </React.Fragment>
                  }
                ></Link>
              </div>
            )}
          </div>
        </div>
        <div className={styles.useCases}>
          {components.slice(1).map((comp, idx) => (
            <div className={styles.useCase} key={idx}>
              <h4 className={styles.caseTitle}>{comp.title}</h4>
              <div className={[styles.caseDescription, 'paragraph'].join(' ')}>
                {comp.subtitle.subtitle.split('\n')[0]}
              </div>
              {comp.subtitle.subtitle.split('\n').length > 1 && (
                <div className={styles.readMore}>
                  <Link
                    to={comp.subtitle.subtitle.split('\n')[1].split(';')[1]}
                    children={
                      <React.Fragment>
                        <span className="paragraph">
                          {comp.subtitle.subtitle.split('\n')[1].split(';')[0]}
                        </span>
                        <img
                          className={styles.arrow}
                          src={Indicator}
                          alt="Indicator"
                        />
                      </React.Fragment>
                    }
                  ></Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <ReversedGradientBorder
        className={styles.gradBorder}
        height="3px"
      ></ReversedGradientBorder>
    </div>
  )
}

export default CustomerUseCases
